import Http from "./base-http";

class UserExemption extends Http {
  addUserExemption(variables) {
    return this.create(variables);
  }
  deleteUserExemp(id) {
    return this.destroy(id);
  }
}
const userExemption = new UserExemption({
  modelUrlPrefix : "UserExemption"
});
export default userExemption;